
import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <marquee>Made and designed by Jayantika</marquee>
    </div>
  );
}

export default Footer;
